const quote = (caption, text) => {
    let val = ''
    if (text.length > 0) {
        val += `<blockquote class="blockquote">
            ${text}
            <div class="blockquote-footer">${caption}</div>
            </blockquote>
            `
    }
    return val
}

module.exports = quote
